export const modalDescriptions = {
  airport: {
    title: 'Co je zahrnuto v našem letištním transferu?',
    subtitle: '✈️ Letištní transfer',
    image: '/img/modalDescription/airport.webp',
    imageAlt: 'Vůz pro letištní transfer',
    ariaLabel: {
      orderButton: 'Přejít na rezervační formulář letištního transferu',
      orderButtonText: 'Objednat transfer',
      closeButton: 'Zavřít modální okno',
    },
    list: [
      'Řidič vás přivítá se jmenovkou u východu z terminálu.',
      'Pomoc se zavazadly.',
      'Sledování letu (víme, pokud má let zpoždění).',
      'Až 60 minut čekání zdarma.',
      'Vozy vyšší třídy (Wi-Fi, voda, dětská sedačka na požádání).',
      'Dostupné trasy: z/na Letiště Václava Havla.',
      'Ceny od 30 €.',
    ],
    text: 'Náš letištní transfer je zárukou klidného začátku nebo konce vaší cesty. Sledujeme váš let a přivítáme vás se jmenovkou v příletové hale. Řidič vám pomůže se zavazadly a odveze vás pohodlným vozem s Wi-Fi až ke dveřím. První hodina čekání je zdarma, takže se nemusíte stresovat v případě zpoždění letu.',
  },

  corporate: {
    title: 'Ideální řešení pro vaši firmu',
    subtitle: '🧑‍💼 Firemní transfer',
    image: '/img/modalDescription/corporate.webp',
    imageAlt: 'Vůz business třídy pro firemní klienty',
    ariaLabel: {
      orderButton: 'Přejít na rezervační formulář firemního transferu',
      orderButtonText: 'Objednat transfer',
      closeButton: 'Zavřít modální okno',
    },
    list: [
      'Služby pro firemní klientelu.',
      'Možnost uzavření smlouvy s firmou.',
      'Měsíční fakturace a reporting.',
      'Řidiči v oblecích, diskrétnost během jízdy.',
      'Vozy business třídy a vyšší.',
      'Objednávky pro akce, konference, delegace.',
      'Sledování trasy přes firemní účet.',
    ],
    text: 'Nabízíme prémiové služby pro firmy, které si cení komfortu a dochvilnosti. Transfery mezi hotely, konferenčními centry a letištěm zajišťují profesionální řidiči se zkušenostmi s VIP klientelou. Možnost uzavření smlouvy a měsíční fakturace. Vaši zaměstnanci budou bezpečně a včas doručeni na místo určení.',
  },

  personal: {
    title: 'Váš osobní řidič na den, týden nebo cestu',
    subtitle: '🚗 Osobní řidič',
    image: '/img/modalDescription/personal.webp',
    imageAlt: 'Osobní řidič s vozem vyšší třídy',
    ariaLabel: {
      orderButton: 'Přejít na rezervační formulář osobního řidiče',
      orderButtonText: 'Objednat řidiče',
      closeButton: 'Zavřít modální okno',
    },
    list: [
      'Možnost pronájmu řidiče na hodiny / celý den.',
      'Jízdy po městě, zastávky, čekání — vše v ceně.',
      'Vozy vyšší třídy s řidičem.',
      'Soukromé jízdy, nákupní výlety, důležitá jednání.',
      'Ideální pro návštěvníky města, VIP klienty, seniory.',
      'Řidiči mluví anglicky/česky.',
    ],
    text: 'Pronájem osobního řidiče je ideálním řešením pro ty, kteří chtějí mít mobilitu a svobodu bez starostí. Řidič vás bude doprovázet po celé trase, ať už bude jakkoli složitá. Můžete si objednat doprovod na nákupy, schůzky nebo i výlet mimo město. Prémiový vůz, zdvořilý servis a úplná diskrétnost — vše je zahrnuto.',
  },

  vip: {
    title: 'Luxus a pohodlí nejvyšší třídy',
    subtitle: '👑 VIP a luxusní služby',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'VIP vůz připravený na cestu',
    ariaLabel: {
      orderButton: 'Přejít na rezervační formulář VIP služby',
      orderButtonText: 'Objednat VIP transfer',
      closeButton: 'Zavřít modální okno',
    },
    list: [
      'Individuální přístup ke každému klientovi.',
      'Vozy nejvyšší třídy.',
      'Řidiči v oblecích se zkušenostmi s VIP hosty.',
      'Úplná diskrétnost.',
      'Doplňky: uvítací balíček, minerální voda, noviny.',
      'Ideální pro obchodní jednání, diplomatické cesty, svatby a společenské události.',
      'Podpora 24/7 a osobní manažer.',
    ],
    text: 'Pronájem osobního řidiče je ideálním řešením pro ty, kteří chtějí mít mobilitu a svobodu bez starostí. Řidič vás bude doprovázet po celé trase, ať už bude jakkoli složitá. Můžete si objednat doprovod na nákupy, schůzky nebo i výlet mimo město. Prémiový vůz, zdvořilý servis a úplná diskrétnost — vše je zahrnuto.',
  },

  tours: {
    title: 'Cestujte pohodlně a s radostí',
    subtitle: '🌍 Výlety a exkurze',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'Vůz pro výlety a exkurze po Evropě',
    ariaLabel: {
      orderButton: 'Přejít na rezervační formulář pro výlety nebo exkurze',
      orderButtonText: 'Objednat výlet',
      closeButton: 'Zavřít modální okno',
    },
    list: [
      'Organizace individuálních i skupinových výletů.',
      'Možnost zvolit průvodce nebo jen řidiče.',
      'Flexibilní trasy po Česku a Evropě (Karlovy Vary, Vídeň, Drážďany, Mnichov aj.).',
      'Komfortní vozy, klimatizace, Wi-Fi, pitná voda.',
      'Zastávky na focení, čas na nákupy, jídlo v místních restauracích.',
      'Cestovní pojištění a podpora na cestě.',
      'Možnost rezervace přes online formulář.',
    ],
    text: 'Objevte Evropu s námi — bez stresu a zbytečných starostí. Organizujeme individuální i skupinové výlety podle vašich přání a zájmů. Naše průvodce vás mohou doprovázet, nebo si užijete pohodlnou jízdu s profesionálním řidičem. Všechny trasy jsou navrženy pro vaše pohodlí, bezpečnost a nezapomenutelné zážitky.',
  },
};
